import { Reveal } from "@/components/Reveal";
import { SERVICES } from "@/lib/site";
import { ArrowUpRight } from "lucide-react";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services"
      className="relative py-24 lg:py-32 bg-[#0b0f17] border-y border-white/10 scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
            <div>
              <div className="rsm-eyebrow mb-5">Capabilities</div>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white max-w-2xl leading-[1.1]">
                Multiple services, one connected pipeline.
              </h2>
            </div>
            <p className="max-w-xs text-sm leading-relaxed text-slate-400">
              From raw data sourcing to booked appointments — each service
              plugs into the next.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {SERVICES.map((s, i) => {
            return (
              <Reveal
                key={s.id}
                delay={(i % 3) * 0.08}
              >
                <div
                  data-testid={`service-card-${s.id}`}
                  className="group relative h-full rounded-2xl border border-white/10 bg-[#121927] p-7 lg:p-8 transition-all duration-300 hover:border-amber-400/40 hover:bg-[#161f31] hover:-translate-y-1"
                >
                  <div className="flex items-start justify-between">
                    <span className="font-mono text-xs uppercase tracking-[0.18em] text-amber-400/70">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <ArrowUpRight
                      size={20}
                      className="text-slate-600 transition-colors group-hover:text-amber-400"
                    />
                  </div>
                  <h3 className="mt-8 font-display text-xl font-bold text-white">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-400">
                    {s.description}
                  </p>
                  <span className="mt-6 inline-block rounded-full border border-white/10 px-3 py-1 text-[11px] font-mono uppercase tracking-wider text-slate-500">
                    {s.tag}
                  </span>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
